import { render } from "./page-login.vue?vue&type=template&id=07ce89fa&scoped=true"
import script from "./page-login.vue?vue&type=script&lang=js"
export * from "./page-login.vue?vue&type=script&lang=js"

import "./page-login.vue?vue&type=style&index=0&id=07ce89fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ce89fa"]])

export default __exports__